import React from "react"
import { graphql } from "gatsby"
// import Img from "gatsby-image"
// import urlBuilder from "@sanity/image-url"
// import PortableText from "@sanity/block-content-to-react"
import { FaPhone, FaStoreAlt } from "react-icons/fa"

import ContactForm from "../components/contactForm"
// import Img from "gatsby-image"
import SEO from "../components/SEO"
import BackgroundImageMain from "../components/BackgroundImageMain"
import {
  ContactSubItem,
  ContactTitle,
  ContactSubContainer,
  ContactIconContainer,
  ContactSubTitle,
  ContactCard,
  CardsContainer,
} from "../components/contactComponents"
import TitleBox from "../components/TitleBox"
import Layout from "../components/layout"

// const staffMembers_ = [
//   {
//     name: "Name 1",
//     jobTitle: "Job Title 1",
//     phone: "555-5555",
//     email: "someAddress@wawakapewin.com",
//   },
//   {
//     name: "Name 2",
//     jobTitle: "Job Title 2",
//     phone: "555-5555",
//     email: "email@example.com",
//   },
//   {
//     name: "Name 3",
//     jobTitle: "Job Title 3",
//     phone: "555-5555",
//     email: "email@example.com",
//   },
//   {
//     name: "Name 4",
//     jobTitle: "Job Title 4",
//     phone: "555-5555",
//     email: "",
//   },
// ]

// const TransparentContainer = ({ children, className = "" }) => (
//   <div className={`bg-black bg-opacity-25 p-10 ${className}`}>{children}</div>
// )

// MAIN COMPONENT

const ContactPage = ({ data }) => {
  // custom header from Sanity. If none provided, this will be null
  // const fluid = data.mapQuery.edges[0].node.childImageSharp.fluid
  // const defaultProfileFixed =
  //   data.defaultProfileImg.edges[0].node.childImageSharp.fixed

  const staffMembers = data.staffMembers.edges

  const { councilMembers } = data

  console.log(councilMembers)

  return (
    //pass custom header to Layout
    <Layout>
      <SEO title="Contact" />
      <BackgroundImageMain className="contactPage settings__greyGradientBkgd">
        <div className="grid  py-20 relative text-white">
          <TitleBox className="justify-self-center  mb-10">Contact Us</TitleBox>
          <div className="grid justify-center  md:grid-flow-col  md:gap-x-20  mx-10">
            {/* Contact Info Grid */}
            {/* CHECK GRID AUTO ROWS */}
            <div className=" text-blue-dark flex flex-col justify-center h-auto ">
              <div className="grid justify-center align-middle mb-10 bg-white bg-opacity-75 p-5  rounded-md">
                <ContactSubContainer
                  className="grid gap-x-5 relative mb-10"
                  style={{
                    gridTemplateColumns: "auto 1fr",
                  }}
                >
                  <ContactIconContainer>
                    <FaPhone className="contactPage__icon " />
                  </ContactIconContainer>

                  <div className="">
                    <ContactSubTitle>Phone</ContactSubTitle>
                    <ContactSubItem>(807) 737-2662</ContactSubItem>{" "}
                    <ContactSubItem>Toll free: 1-866-877-6057</ContactSubItem>
                  </div>
                </ContactSubContainer>
                <ContactSubContainer>
                  <ContactIconContainer>
                    <FaStoreAlt className="contactPage__icon" />
                  </ContactIconContainer>
                  <div className="">
                    <ContactSubTitle>Mailing Address</ContactSubTitle>
                    <ContactSubItem>Wawakapewin First Nation</ContactSubItem>
                    <ContactSubItem>P.O. Box 477</ContactSubItem>
                    <ContactSubItem>Sioux Lookout, ON</ContactSubItem>
                    <ContactSubItem>P8T 1A8</ContactSubItem>
                  </div>
                </ContactSubContainer>
              </div>
            </div>
            <div>
              <div className=" bg-blue-dark px-8 py-5  rounded-md">
                <ContactTitle className="">Send Us a Message</ContactTitle>
                <ContactForm />
              </div>
            </div>
          </div>

          {/* Staff Section */}
          <section className="grid my-10 " id="staff">
            <ContactTitle>Staff</ContactTitle>
            <CardsContainer>
              {staffMembers.map((staffMember) => {
                const {
                  name,
                  jobTitle,
                  phone,
                  extension,
                  email,
                  profilePhoto,
                  id,
                } = staffMember.node

                const fixed = profilePhoto ? profilePhoto.asset.fixed : null

                // {
                //   /* debugger */
                // }

                return (
                  <ContactCard
                    fixed={fixed}
                    name={name}
                    jobTitle={jobTitle}
                    email={email}
                    phone={phone}
                    extension={extension}
                    key={`${id}-staffCard`}
                  />
                )
              })}
            </CardsContainer>
          </section>
          {/* Council Section */}
          <section>
            <ContactTitle>Chief and Council</ContactTitle>
            <CardsContainer>
              {councilMembers.edges.map((councilMember) => {
                const {
                  name,
                  jobTitle,
                  phone,
                  email,
                  profilePhoto,
                  extension,
                  id,
                } = councilMember.node

                // {
                //   /* default photo if no profile photo provided */
                // }
                const fixed = profilePhoto ? profilePhoto.asset.fixed : null

                return (
                  <ContactCard
                    fixed={fixed}
                    name={name}
                    jobTitle={jobTitle}
                    email={email}
                    phone={phone}
                    extension={extension}
                    key={`${id}-councilCard`}
                  />
                )
              })}
            </CardsContainer>
          </section>
        </div>
      </BackgroundImageMain>
      {/* <Img className="contactPage__map" fluid={fluid} /> */}
      {/* <UnderDevelopment /> */}
    </Layout>
  )
}

export default ContactPage

export const query = graphql`
  query {
    mapQuery: allFile(filter: { name: { eq: "calgary_cochrane_map" } }) {
      edges {
        node {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    defaultProfileImg: allFile(
      filter: { relativePath: { eq: "icons/profile.png" } }
    ) {
      edges {
        node {
          relativePath
          childImageSharp {
            fixed(width: 200) {
              ...GatsbyImageSharpFixed
            }
          }
        }
      }
    }
    staffMembers: allSanityStaff(
      filter: { active: { eq: true } }
      sort: { fields: [weight, name], order: [ASC, ASC] }
    ) {
      edges {
        node {
          id
          name
          jobTitle
          phone
          extension
          active
          email
          profilePhoto {
            asset {
              fixed(width: 200) {
                ...GatsbySanityImageFixed
              }
            }
          }
        }
      }
    }

    councilMembers: allSanityCouncilMember(
      sort: { fields: [weight, name], order: [ASC, ASC] }
    ) {
      edges {
        node {
          id
          weight
          name
          phone
          extension
          email
          jobTitle
          profilePhoto {
            asset {
              fixed(width: 200) {
                ...GatsbySanityImageFixed
              }
            }
          }
        }
      }
    }
  }
`
